import React from 'react'

interface RepeatableEntryListProps<TItem> {
  items: TItem[]
  itemTitle: string
  addButtonText: string
  onAdd: () => void
  onRemove: (index: number) => void
  renderItemFields: (index: number) => React.ReactNode
}

const RepeatableEntryList = <TItem,>({
  items,
  itemTitle,
  addButtonText,
  onAdd,
  onRemove,
  renderItemFields,
}: RepeatableEntryListProps<TItem>) => {
  return (
    <div className='wizard-repeat-list'>
      {items.map((_, index) => (
        <div key={`${itemTitle}-${index}`}>
          <hr className='mt-4 mb-2'></hr>
          <div className='wizard-repeat-item'>
            {index > 0 && (
              <span className='fw-bold text-uppercase ls-2 my-2 fs-6' style={{color: '#6B7280'}}>
                {itemTitle} {index + 1}
              </span>
            )}
            {index > 0 && (
              <div className='wizard-repeat-item-header position-relative'>
                <div className='fw-semibold small mb-0'></div>

                <button
                  type='button'
                  className='btn btn-sm btn-icon btn-light position-absolute top-0 end-0 remove-btn fs-6'
                  style={{color: '#EF4444'}}
                  onClick={() => onRemove(index)}
                  title={`Remove ${itemTitle.toLowerCase()}`}
                  aria-label={`Remove ${itemTitle.toLowerCase()}`}
                >
                  Remove
                </button>
              </div>
            )}

            {renderItemFields(index)}
          </div>
        </div>
      ))}

      <button type='button' className='btn btn-white border w-100 mt-2' onClick={onAdd}>
        <i className='bi bi-plus-lg me-2'></i>
        {addButtonText}
      </button>
    </div>
  )
}

export default RepeatableEntryList
